import RentalTotalPriceFormatted from './RentalTotalPriceFormatted';

export default RentalTotalPriceFormatted;
